export const selectAllSegments = state => state.segments.allSegments;
export const selectRequestingGetSegments = state =>
  state.segments.requestingGetSegments;
export const selectAllProducts = state => state.productsReducer.allProducts;
